/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/audit-support-api-client";
import type { BulkUploadAvgFilesMutationRequest, BulkUploadAvgFilesMutationResponse } from "../models/BulkUploadAvgFiles";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { bulkUploadAvgFiles } from "../axios/bulkUploadAvgFiles";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const bulkUploadAvgFilesMutationKey = () => ["audit-support-api", { url: '/avg-files/bulk-upload' }] as const

export type BulkUploadAvgFilesMutationKey = ReturnType<typeof bulkUploadAvgFilesMutationKey>

export function bulkUploadAvgFilesMutationOptions<TContext = unknown>(config: Partial<RequestConfig<BulkUploadAvgFilesMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = bulkUploadAvgFilesMutationKey()
        return mutationOptions<BulkUploadAvgFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadAvgFilesMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return bulkUploadAvgFiles(data, config)
          },
        })

}

/**
 * @description Upload multiple files for processing and storage. Files are processed sequentially.
 * @summary Bulk upload AVG files
 * {@link /avg-files/bulk-upload}
 */
export function useBulkUploadAvgFiles<TContext>(options: 
{
  mutation?: UseMutationOptions<BulkUploadAvgFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadAvgFilesMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<BulkUploadAvgFilesMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? bulkUploadAvgFilesMutationKey()

          const baseOptions = bulkUploadAvgFilesMutationOptions(config) as UseMutationOptions<BulkUploadAvgFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadAvgFilesMutationRequest}, TContext>
          

          return useMutation<BulkUploadAvgFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadAvgFilesMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<BulkUploadAvgFilesMutationResponse, ResponseErrorConfig<Error>, {data: BulkUploadAvgFilesMutationRequest}, TContext>
      
}